import { Container, Paper, Typography } from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import { Trans } from "react-i18next";
import { useHistory } from "react-router";
import { getEnv } from "../config/Config";
import EADrawer from "./EADrawer";
import EAAppBar from "./EAAppBar";
import { useContext } from 'react';
import { Context } from '../states/Store';
import i18next from 'i18next';

const useStyles = makeStyles()((theme) => ({
    containerBackground: {
      padding: "4em",
      width: "100vw",
      height: "100vh",
      position: 'absolute',
      top:0, left:0, right:0, bottom:0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "no-repeat url(/img/background/bg-manager.png)",
      maxWidth: "100vw !important",
      backgroundSize: "cover",
    },
    paperBackground: {
      padding: "40px 24px 15px 24px",
      width: "582px",
      borderRadius: "10px",
    },
    textStyle: {
      whiteSpace: 'pre-wrap',
      fontSize: "16px",
      color: "#535362",
      textAlign: "center",
      marginBottom: "14px"
    },
}));

const UnAuthorized = () => {
  const [state] = useContext(Context);
  const { classes } = useStyles();
  let history = useHistory();

    return (
      <Container className={classes.containerBackground} style={{paddingLeft: state?.drawerIsOpened ? "250px" : "50px"}}>
        <Paper className={classes.paperBackground}>
          <EAAppBar disableProfile />
          <EADrawer />

          <Typography className={classes.textStyle}>
            {i18next.t("unauthorized.text")}
          </Typography>

          {history?.location?.search !== '?ssoMode=true' && (
            <>
              <Typography className={classes.textStyle}>
                {i18next.t("unauthorized.AccessToDo")}
              </Typography>

              <Typography className={classes.textStyle}>
                <Trans i18nKey="unauthorized.redirect-link">
                  Suivez <a href={getEnv("REACT_APP_DO_URL")}>ce lien</a> et connectez-vous avec vos identifiants habituels.
                </Trans> <br/>
                {i18next.t("unauthorized.contactSupportError")}
              </Typography>
            </>
          )}
        </Paper>
      </Container>
    );
}

export default UnAuthorized;
